export const constants = {
  formErrorToast: "Please enter the required details to continue",
  addErrorToast: "Please add all traveller details to continue",
};
